import { action, observable } from 'mobx';
import { HttpClient, IConfig, setMap } from 'Mri.Web.Common';

export class AlertActionsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadRecipientsAsync(config?: IConfig) {
        const recipients = await this.httpClient.get<Mri.DisplayAlerts.Recipient[]>(
            `/api/v1/alert-actions/recipients`,
            config
        );

        setMap(this.recipients, recipients, r => r.id);
    }

    @action
    public async loadAllAsync() {
        const alertActions = await this.httpClient.get<Mri.DisplayAlerts.AlertAction[]>(`/api/v1/alert-actions`);

        setMap(this.alertActions, alertActions, d => d.alertActionGuid);
    }

    @action
    public async loadAsync(guid: string) {
        const alertAction = await this.httpClient.get<Mri.DisplayAlerts.AlertAction>(`/api/v1/alert-actions/${guid}`);

        if (alertAction) this.alertActions.set(alertAction.alertActionGuid, alertAction);
    }

    @action
    public async createAsync(model: Mri.DisplayAlerts.AlertAction) {
        const alertAction = await this.httpClient.post<Mri.DisplayAlerts.AlertAction>(`/api/v1/alert-actions`, model);

        if (alertAction) this.alertActions.set(alertAction.alertActionGuid, alertAction);
    }

    @action
    public async updateAsync(guid: string, model: Mri.DisplayAlerts.AlertAction) {
        const alertAction = await this.httpClient.put<Mri.DisplayAlerts.AlertAction>(
            `/api/v1/alert-actions/${guid}`,
            model
        );

        if (alertAction) this.alertActions.set(alertAction.alertActionGuid, alertAction);
    }

    @action
    public async deleteAsync(guid: string) {
        await this.httpClient.delete<Mri.DisplayAlerts.AlertAction>(`/api/v1/alert-actions/${guid}`);

        this.alertActions.delete(guid);
    }

    @action
    public async applyAsync(model: Mri.DisplayAlerts.AlertAction) {
        const alertAction = await this.httpClient.put<Mri.DisplayAlerts.AlertAction>(
            `/api/v1/alert-actions/apply`,
            model
        );

        if (alertAction) this.alertActions.set(alertAction.alertActionGuid, alertAction);
    }

    @observable
    public alertActions = new Map<string, Mri.DisplayAlerts.AlertAction>();

    @observable
    public recipients = new Map<string, Mri.DisplayAlerts.Recipient>();

    private readonly httpClient: HttpClient;
}
